// extracted by mini-css-extract-plugin
export default {"container":"_9b94aeda","header":"_b423cea2","italicHeader":"_bb57d038","content":"_6e3d4814","bold":"_f159d0b8"};